import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async indexAnnounce(actId, params) {
    const _params = {
      factory: store.state.app.factory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'act',
      parentId: actId,
      modelName: 'act_version/index/announce',
      params: _params,
    });
    return res;
  },
  async show(versionId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.show({
      modelName: 'act_version',
      modelId: versionId,
      params,
    });
    return res;
  },
}